import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import * as Sentry from "@sentry/react";
import Landing from "./pages/Landing";
import AuthVerify from "./pages/AuthVerify";
import Dashboard from "./pages/Dashboard";
import Chat from "./pages/Chat";
import Pipeline from "./pages/Pipeline";
import Artifacts from "./pages/Artifacts";
import Review from "./pages/Review";

export default function App() {
  return (
    <Sentry.ErrorBoundary
      fallback={({ resetError }) => (
        <div style={{ padding: "2rem", textAlign: "center" }}>
          <h2>Something went wrong</h2>
          <p>This error has been automatically reported.</p>
          <button onClick={resetError}>Try Again</button>
        </div>
      )}
    >
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/auth/verify" element={<AuthVerify />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/chat" element={<Chat />} />
          <Route path="/pipeline" element={<Pipeline />} />
          <Route path="/artifacts" element={<Artifacts />} />
          <Route path="/review" element={<Review />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  );
}
